import { defineStore } from 'pinia'
import { ref } from 'vue'
import { createChatCore } from './chatCore.js'

/**
 * Chat dell'admin con l'IA sullo stato dei processi.
 *
 * Il riepilogo dei processi lo tiene il Backend, per conversazione (`conversationId`): così più
 * domande della stessa chat vedono gli stessi dati, finché non si chiede di aggiornarli.
 */
export const useAdminChatStore = defineStore('adminChat', () => {
  const refreshNext = ref(false)

  const core = createChatCore({
    modelsUrl: () => '/api/admin-chat/models',
    streamUrl: () => '/api/admin-chat/stream',
    buildBody: ({ history, conversationId, model }) => ({
      conversationId,
      model,
      messages: history,
      refreshSnapshot: refreshNext.value
    })
  })

  async function send(text) {
    await core.send(text)
    // Il riepilogo si ricostruisce solo se la richiesta è arrivata: dopo un errore resta da aggiornare.
    const last = core.messages.value[core.messages.value.length - 1]
    if (last && !last.error) refreshNext.value = false
  }

  function newChat() {
    core.newChat()
    refreshNext.value = false
  }

  /** Il prossimo messaggio ricostruisce il riepilogo dei processi. */
  function refreshData() {
    refreshNext.value = true
  }

  return { ...core, refreshNext, send, newChat, refreshData }
})
